import React, { 
  useState,
  useEffect
} from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import toast from 'react-hot-toast';
import { validateExpenseArrayObjects } from '../../Components/Validations/ArrayObjectValidation';
import dayjs from 'dayjs';

import { 
  Layout,
  Table,
  Col, 
  Row,
  Button,
  // Modal,
  Upload,
  Divider,
  Form,
  Select,
  Input,
  DatePicker,
  Radio,
  InputNumber,
  Space,

} from 'antd'
import { 
  InboxOutlined,
  DeleteOutlined,
  ProductOutlined,
} from '@ant-design/icons';

import { formatAmount, formatDate } from '../../Utils/Common';
import { useNavigate, useParams } from 'react-router-dom';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'
import { SeeAttachment } from '../../Components/SeeAttachment';
import TextArea from 'antd/es/input/TextArea';
const { Option } = Select;
const { Item } = Form;

const EditExpense = () => {
  const [editExpenseForm] = Form.useForm();
  const { callPost, loading } = usePostRequest(()=>{
    navigate('/expense')
  });
  const navigate = useNavigate()
  const { id } = useParams();
  const [newAttachment, setNewAttachment] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState('cash');
  const [unitId, setUnitId] = useState('');
  const [paymentStatus, setPaymentStatus] = useState(false);
  const [tenantData, setTenantData] = useState([]);
  const [rentalUnitData, setRentalUnitData] = useState([]);
  const [ownerData, setOwnerData] = useState([]);
  const [supplierData, setSupplierData] = useState([]);
  const [attachmentsData, setAttachmentsData] = useState([]);
  const [type, setType] = useState('internal');
  const [isLoading, setIsLoading] = useState(false);
  // const [isDisabled, setIsDisabled] = useState(true);
  const [dataSource, setDataSource] = useState([
    {
      item: '',
      amount: '',
    },
    {
      item: '',
      amount: '',
    },
  ]);
  const customSpinner = <ProductOutlined style={{ fontSize: 24 }} spin />;

  // const values = Form.useWatch([], editExpenseForm);
  // React.useEffect(() => {
  //     editExpenseForm.validateFields({
  //     validateOnly: true,
  //     }).then(() => {
  //     setIsDisabled(false);
  //     },
  //     () => {
  //     setIsDisabled(true);
  //     },
  //     );
  // }, [values, editExpenseForm, dataSource]);

  const handleInputChange = (e, fieldName, recordKey) => {
    const updatedDataSource = dataSource.map((item, index) => {
      if (index === recordKey) {
        if(fieldName === "amount"){
          return { ...item, [fieldName]: e };
        } else {
          return { ...item, [fieldName]: e.target.value };
        }
      }
      return item;
    });
    setDataSource(updatedDataSource);
  };
  const handleAddRow = () => {
    const newRow = {
      item: "",
      amount: "",
    };
    setDataSource(prev => [...prev, newRow]);
  };

  const handleDeleteRow = (rowId) => {
    const newData = [...dataSource];
    newData.splice(rowId, 1); 
    setDataSource(() => newData)
  };

  const grandTotal = dataSource.reduce((total, item) => {
    return total + parseFloat(item.amount || 0);
  }, 0);

  const columns = [
    {
      title: 'Items',
      dataIndex: 'item',
      render: (_, record, index) => (
        <Input
          disabled={paymentStatus}
          value={record.item}
          onChange={(e) => handleInputChange(e, 'item', index)}
        />
      ),
    },
    {
      title: 'Amounts',
      dataIndex: 'amount',
      render: (_, record, index) => (
        <InputNumber
          disabled={paymentStatus}
          style={{width:'100%'}}
          value={record.amount}
          onChange={(e) => handleInputChange(e, 'amount', index)}
        />
      ),
    },
    {
      title: 'Action',
      dataIndex: 'action',
      align: 'center',
      render: (_,record, index) => (
       <div className='center'>
          <Button
            disabled={paymentStatus}
            icon={<DeleteOutlined />}
            onClick={() => handleDeleteRow(index)}
            type="link"
            size='large'
            danger
          />
       </div>
      ),
    },
  ];

  const options = [
    {
      label: 'Cash',
      value: 'cash',
    },
    {
      label: 'Check',
      value: 'check',
    },
    {
      label: 'Other',
      value: 'other',
    },
  ];
  async function fetchTenantData() {
    // setIsLoading(true);

    const response = await UseGetRequest("tenants/get", {tenant_id: ''});
    if (response.data) {
      setTenantData(response.data.data);
    } else {
      setTenantData([])
    }

    // setIsLoading(false);
  }
  async function fetchOwnerData() {
    // setIsLoading(true);

    const response = await UseGetRequest("owners/get", {tenant_id: ''});
    if (response.data) {
      setOwnerData(response.data.data);
    } else {
      setOwnerData([])
    }

    // setIsLoading(false);
  }

  async function fetchRentalUnitOwner(ownerId, unitId) {
    const response = await UseGetRequest("rental_units/get", {owner_id: ownerId});
    if (response?.data) {
      setRentalUnitData(response?.data?.data);
      if(unitId){
        editExpenseForm.setFieldsValue({
          rental_unit_id: unitId,
        });
      } else {
        editExpenseForm.setFieldsValue({
          rental_unit_id: '',
        });
      }
    } else {
      setRentalUnitData([])
      editExpenseForm.setFieldsValue({
        rental_unit_id: '',
      });
    }
  }

  async function fetchSupplierData() {
    // setIsLoading(true);

    const response = await UseGetRequest("suppliers/get", {supplier_id: ''});
    if (response.data) {
      setSupplierData(response.data.data);
    } else {
      setSupplierData([])
    }

    // setIsLoading(false);
  }

  async function fetchExpenseData() {
    setIsLoading(true)
    const response = await UseGetRequest("expenses/get", {expense_id: id});

    if (response?.data) {
      const data = response?.data?.data[0]
      let attachment = data?.attachments?.map((file) => ({
        ...file,
        link: (
          <SeeAttachment
            attachments={[
              { file_url: file.file_url, file_name: file.file_name },
            ]}
          />
        ),
      })) 

      let items = data?.items?.map((data) => ({
        ...data,
        items: data.item,
        amounts: data.amount,
      })) 

      setNewAttachment(attachment)
      setAttachmentsData(fileUrlFormat(data?.attachments))
      editExpenseForm.setFieldsValue({
        supplier_id: data?.supplier_id || "",
        tenant_id: data?.tenant_id || "",
        owner_id: data?.owner_id || "",
        ...(data.type === "owner" && {rental_unit_id: data?.rental_unit_id || ""}),
        description: data?.description || "",
        expense_date: dayjs(data.expense_date) || "",
        date_covered: data.date_covered ? dayjs(data.date_covered) : "",
        main_usage: data?.main_usage || "",
        sub_usage: data?.sub_usage || "",
        remarks: data?.remarks || "",
        type: data.type,

        paid_amount: data?.paid_amount || "",
        payment_date: dayjs(data?.payments?.payment_date),
        payment_remarks: data?.payments?.payment_remarks || "",

        check_no: data?.payments?.check_no || "",
        check_date: dayjs(data?.payments?.check_date),
        bank: data?.payments?.bank || "",
    
        other_type: data?.payments?.other_type || "",
        reference_no: data?.payments?.reference_no || "",
      });
      setUnitId(data?.rental_unit_id )
      setType(data.type);
      setDataSource(items)
      setPaymentMethod(data?.payments?.payment_type)
      setPaymentStatus(data?.status === "completed" ? true : false)
      if(data.type === "owner"){
        fetchRentalUnitOwner(data?.owner_id, data?.rental_unit_id)
      }
      // setPaymentMethod(data?.p)
    } else {
      editExpenseForm.resetFields();
    }
    setIsLoading(false);
  }
  const fileUrlFormat = (files) => {
    if(files){
      return files?.map(file => ({
        uid: file.id,
        id: file.id,
        name: file.file_name,
        status: "done",
        url: file.file_url,
        fileType: file.file_type
      }));
    }
  };
  const handleEditExpense = () => {
    editExpenseForm.validateFields().then(values => {
      const resetData = {
        expense_id: id,
        supplier_id: values?.supplier_id || "",
        tenant_id: values?.tenant_id || "",
        owner_id: values?.owner_id || "",
        ...(type === "tenant" ? {rental_unit_id: unitId || ""} : {rental_unit_id: values?.rental_unit_id || ""}),
        main_usage: values?.main_usage || "",
        sub_usage: values?.sub_usage || "",
        description: values?.description || "",
        remarks: values?.remarks || "",
        total: grandTotal || "",
        
        payment_type: paymentMethod || "",
        paid_amount: values?.paid_amount || "",
        payment_remarks: values?.payment_remarks || "",

        check_no: values?.check_no || "",
        bank: values?.bank || "",

        other_type: values?.other_type || "",
        reference_no: values?.reference_no || "",
      };

        resetData.expense_date = values?.expense_date ? values.expense_date.format("YYYY-MM-DD") : "";
        resetData.date_covered = values?.date_covered ? values.date_covered.format("YYYY-MM-DD") : "";
        resetData.payment_date = values?.payment_date ? values.payment_date.format("YYYY-MM-DD") : "";
        resetData.check_date = values?.check_date ? values.check_date.format("YYYY-MM-DD") : "";
        
        resetData.items = dataSource.map((item)=>item.item)
        resetData.item_ids = dataSource.map((item)=>item.id || "")
        resetData.amounts = dataSource.map((item)=>item.amount)

        const file = attachmentsData
        .filter(data => data.originFileObj)
        .map(data => data.originFileObj);
        
        const attch_ids = attachmentsData
        .filter(data => data.id)
        .map(data => data.id);
        
        var finalValues = Object.entries({...resetData, attachments: file, attachment_ids: attch_ids}).map(([key, value]) => ({
            key,
            value,
        }));


        callPost(
            "expenses/update", 
            finalValues,
            true,
        );
    }).catch(errorInfo => {
      toast.error('Validation Failed:', errorInfo);
    });
  };

  const onMethodChange = ({ target: { value } }) => {
    setPaymentMethod(value);
    if(value === "check"){
      editExpenseForm.resetFields(['other_type','reference_no'])
    }else if(value === "other"){
      editExpenseForm.resetFields(['bank','check_date','check_no'])
    }
  };

  const normFile = (e) => {

    if (Array.isArray(e)) {
        setAttachmentsData(e)
    }
    setAttachmentsData(e?.fileList)
    
  };

  const columns2 = [
    {
      title: 'Date Added',
      dataIndex: 'added_on',
      key: 'added_on',
      width: '30%',
      render: (amount) => formatDate(amount),
    },
    {
      title: 'Attachments',
      dataIndex: 'link',
      key: 'link',
    },
  ];  

  const handleDeleteAttachment = (file) => {
    const updatedAttachments = attachmentsData.filter(item => item !== file);
    setAttachmentsData(updatedAttachments);
  };
  
  const handleType = (value) => {
    setType(value)
    editExpenseForm.resetFields(['bank','check_date','check_no', 'other_type', 'reference_no']);
  };  

  const handleUnits = (rental_id, type) => {
    if(type === "owner"){
      fetchRentalUnitOwner(rental_id)
    } else if (type === "tenant"){
      var renter = tenantData.filter(item => item.id === rental_id)
      setUnitId(renter[0]?.rental_unit_id)
    } else {
      setRentalUnitData([])
      setUnitId('')
    }
  }

  useEffect(() => {
    switch (type) {
      case "tenant":
        fetchTenantData();
        break;
      case "owner":
        fetchOwnerData();
        break;
      default:
        break;
    }
  }, [type]);

  useEffect(() => {
    fetchSupplierData();
  }, []);

  useEffect(() => {
    if(id){
      fetchExpenseData();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  return (
    <Layout className='page'>
      <Navbar/>
      <Layout className='content-container overflow-y'>
          <Row>
              <Col span={24} className='header-container p-3'>
                 {paymentStatus ? "VIEW EXPENSE" : "EDIT EXPENSE"}
              </Col>
          </Row>
         
          <Row>
              <Col span={24} className='p-3'>
             
                  <Form form={editExpenseForm} layout="vertical">
                    <Divider className='divider-text'>Unit Information</Divider>
                      <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                        <Col span={8} className='p-2'>
                          <Item
                            label="Supplier Tradename"
                            name="supplier_id"
                            rules={[{ required: true, message: 'Please select your Supplier' }]} // Adjusted message
                          >
                            <Select disabled={paymentStatus} placeholder="Select a supplier">
                              {supplierData.map((option, index) => (
                                <Option key={index} value={option.id}>{option.tradename}</Option>
                              ))}
                            </Select>
                          </Item>
                        </Col>
                        <Col span={8} className='p-2'>
                          <Item
                              label="Expense Date"
                              name="expense_date"
                              // className="mt-2"
                              rules={[{ required: true, message: 'Please select a Expense Date' }]}
                          >
                              <DatePicker disabled={paymentStatus} style={{ width: '100%' }} />
                          </Item>
                        </Col>
                        <Col span={8} className='p-2'>
                          <Item
                            label="Expense Description"
                            name="description"
                            rules={[{ required: true, message: 'Please enter your Description!' }]}
                          >
                            <Input disabled={paymentStatus} />
                          </Item>
                        </Col>
                      </Row>
                      <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                        <Col span={8} className='p-2'>
                          <Item
                            label="Usage"
                            name="main_usage"
                            // rules={[{ required: true, message: 'Please enter your Name!' }]}
                          >
                            <Input disabled={paymentStatus} />
                          </Item>
                        </Col>
                        <Col span={8} className='p-2'>
                          <Item
                            label="Sub Usage"
                            name="sub_usage"
                            // rules={[{ required: true, message: 'Please enter your Name!' }]}
                          >
                            <Input disabled={paymentStatus} />
                          </Item>
                        </Col>
                        <Col span={8} className='p-2'>
                          <Item
                            label="Date Covered"
                            name="date_covered"
                            // className="mt-2"
                            // rules={[{ required: true, message: 'Please select a Date Covered' }]}
                          >
                            <DatePicker disabled={paymentStatus} style={{ width: '100%' }} />
                          </Item>
                        </Col>
                      </Row>
                      <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                        <Col span={8} className='p-2'>
                          <Item
                            label="Type"
                            name="type"
                          >
                            <Select disabled={paymentStatus} placeholder="Select a Type" onChange={handleType}>
                              <Option key='internal' value="internal">Internal</Option>
                              <Option key='tenant' value="tenant">Tenant</Option>
                              <Option key='owner' value="owner">Owner</Option>
                            </Select>
                          </Item>
                        </Col>
                        {
                          type === "tenant" && (
                            <Col span={8} className='p-2'>
                              <Item
                                label="Tenant"
                                name="tenant_id"
                                rules={[{ required: true, message: 'Please select a Tenant' }]}
                              >
                                <Select 
                                  placeholder="Select a Tenant"
                                  showSearch
                                  disabled={paymentStatus}
                                  onChange={(e) => handleUnits(e, "tenant")}
                                  filterOption={(input, option) =>
                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                  }
                                >
                                  {tenantData.map((option, index) => (
                                    <Option key={index} value={option.id}>{option.concatenated_tenant}</Option>
                                  ))}
                                </Select>
                              </Item>
                            </Col>
                          )
                        }
                        {
                          type === "owner" && (
                            <Col span={8} className='p-2'>
                              <Item
                                label="Owner"
                                name="owner_id"
                                rules={[{ required: true, message: 'Please select a Owner' }]}
                              >
                                <Select 
                                  placeholder="Select a Owner"
                                  showSearch
                                  disabled={paymentStatus}
                                  onChange={(e) => handleUnits(e, "owner")}
                                  filterOption={(input, option) =>
                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                  }
                                >
                                  {ownerData.map((option, index) => (
                                    <Option key={index} value={option.id}>{option.name}</Option>
                                  ))}
                                </Select>
                              </Item>
                            </Col>
                          )
                        }
                        {
                          (type === "owner") && (
                            <Col span={8} className='p-2'>
                              <Item
                                label="Rental Unit"
                                name="rental_unit_id"
                                rules={[{ required: true, message: 'Please select a Rental Unit' }]}
                              >
                                <Select 
                                  placeholder="Select a Owner"
                                  showSearch
                                  disabled={paymentStatus}
                                  filterOption={(input, option) =>
                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                  }
                                >
                                  {
                                    rentalUnitData.map((option, index) => (
                                      <Option key={index} value={option.id}>{option.name}</Option>
                                    ))
                                  }
                                </Select>
                              </Item>
                            </Col>
                          )
                        }
                      </Row>
                      <Row>
                        <Col span={8} className='p-2'>
                          <Item
                            label="Remarks"
                            name="remarks"
                            // rules={[{ required: true, message: 'Please enter your Name!' }]}
                          >
                            <TextArea disabled={paymentStatus} />
                          </Item>
                        </Col>
                      </Row>
                      <Divider className='divider-text'>List of Purchased Items</Divider>
                      {
                        validateExpenseArrayObjects(dataSource) && (
                          <Row>
                            <Col span={24} className='p-3 logout-icon'>
                              Required*
                            </Col>
                          </Row>
                        )
                      }
                       
                      <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                        <Col span={24} className='p-2'>
                        <Table
                          dataSource={dataSource}
                          columns={columns}
                          pagination={false}
                          bordered
                        />
                        <Button disabled={paymentStatus} type="primary" className='mt-4' onClick={handleAddRow}>
                          Add Row
                        </Button>
                        </Col>
                      </Row>
                      <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                        <Col span={12}>
                         
                        </Col>
                        <Col span={12} className='p-3 amount-total' align='right'>
                          Total: {formatAmount(grandTotal)}
                        </Col>
                      </Row>
                      <Row className='my-5'>
                        <Col span={24}>
                          <Table 
                            columns={columns2} 
                            dataSource={newAttachment} 
                            pagination={false}
                            loading={{
                              indicator: customSpinner, // Use custom spinner
                              spinning: isLoading, // Set spinning based on loading state
                            }}
                          />
                        </Col>
                      </Row>
                      <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                        <Col span={24} className='p-2'>
                          <Form form={editExpenseForm} layout="vertical">
                            <Item 
                              label="Attachment"
                              name="attachments" 
                              // valuePropName="fileList" 
                              getValueFromEvent={normFile} 
                              noStyle
                            >
                              <Upload.Dragger 
                                multiple
                                name="files" 
                                disabled={paymentStatus}
                                // action="/upload.do"
                                fileList={attachmentsData}               
                                beforeUpload={() => false}
                                onRemove={handleDeleteAttachment}
                              >
                              <p className="ant-upload-drag-icon">
                                  <InboxOutlined />
                              </p>
                              <p className="ant-upload-text">Click or drag file to this area to upload</p>
                              <p className="ant-upload-hint">Support for a single or bulk upload.</p>
                              </Upload.Dragger>
                            </Item>
                          </Form>
                        </Col>
                      </Row>
                      {
                        type === "internal" && (
                          <>
                            <Divider className='divider-text'>Edit Payment</Divider>

                            <Row gutter={[16, 16]} className='responsive-inline responsive-width mt-2'>
                              <Col span={24} className='p-2'>
                                  <Radio.Group options={options} onChange={onMethodChange} value={paymentMethod} optionType="button" />
                              </Col>
                            </Row>

                            <Form form={editExpenseForm} layout="vertical">
                              <Row gutter={[16, 16]} className='responsive-inline responsive-width mt-2'>
                                <Col span={8} className='p-2'>
                                  <Item
                                    label="Amount"
                                    name="paid_amount"
                                    className='p-0 m-0'
                                    rules={[{ required: true, message: 'Please enter your Name!' }]}
                                  >
                                    <InputNumber
                                      disabled={paymentStatus}
                                      style={{width:'100%'}}
                                    />
                                  </Item>
                                </Col>
                                <Col span={8} className='p-2'>
                                  <Item
                                    label="Payment Date"
                                    name="payment_date"
                                    className='p-0 m-0'
                                    rules={[{ required: true, message: 'Please enter your Payment Date!' }]}
                                  >
                                    <DatePicker disabled={paymentStatus} style={{width:'100%'}} format="YYYY-MM-DD"/>
                                  </Item>
                                </Col>
                                <Col span={8} className='p-2'>
                                  <Item
                                    label="Remarks"
                                    name="payment_remarks"
                                    className='p-0 m-0'
                                  >
                                    <TextArea disabled={paymentStatus}/>
                                  </Item>
                                </Col>
                              </Row>
                              <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                {
                                  paymentMethod === "check" && (
                                    <>
                                      <Col span={8} className='p-2'>
                                        <Item
                                          label="Bank Name"
                                          name="bank"
                                          className='p-0 m-0'
                                          rules={[{ required: true, message: 'Please enter your Bank Name!' }]}
                                        >
                                          <Input disabled={paymentStatus}/>
                                        </Item>
                                      </Col>
                                      <Col span={8} className='p-2'>
                                        <Item
                                          label="Check Date"
                                          name="check_date"
                                          className='p-0 m-0'
                                          rules={[{ required: true, message: 'Please enter your Check Date!' }]}
                                        >
                                          <DatePicker disabled={paymentStatus} style={{width:'100%'}} format="YYYY-MM-DD"/>
                                        </Item>
                                      </Col>
                                      <Col span={8} className='p-2'>
                                        <Item
                                          label="Check Number"
                                          name="check_no"
                                          className='p-0 m-0'
                                          rules={[{ required: true, message: 'Please enter your Check Number!' }]}
                                        >
                                          <Input disabled={paymentStatus}/>
                                        </Item>
                                      </Col>
                                    </>
                                  )
                                }
                                {
                                  paymentMethod === "other" && (
                                    <>
                                      <Col span={8} className='p-2'>
                                        <Item
                                          label="Type"
                                          name="other_type"
                                          className='p-0 m-0'
                                          rules={[{ required: true, message: 'Please enter your Type!' }]}
                                        >
                                          <Input disabled={paymentStatus}/>
                                        </Item>
                                      </Col>
                                      <Col span={8} className='p-2'>
                                        <Item
                                          label="Reference Number"
                                          name="reference_no"
                                          className='p-0 m-0'
                                          rules={[{ required: true, message: 'Please enter your Reference Number!' }]}
                                        >
                                          <Input disabled={paymentStatus}/>                                  
                                        </Item>
                                      </Col>
                                    </>
                                  )
                                }
                              </Row>
                            </Form>
                          </>
                        )
                      }
                      <Row className='btn-footer'>
                        <Space className='p-2'>
                          <Button
                            onClick={() => navigate('/expense')}
                            className='btn-header'
                          >
                            Close
                          </Button>
                       
                          {
                            !paymentStatus && (
                              <Button
                                onClick={handleEditExpense}
                                type='primary'
                                loading={loading}
                                className='btn-header'
                                disabled={
                                  validateExpenseArrayObjects(dataSource)
                                  // isDisabled
                                }
                              >
                                Save
                              </Button>
                            )
                          }
                        </Space>
                      </Row>
                  </Form>
              </Col>
          </Row>
      </Layout>
  </Layout>
)
}

export default EditExpense
